import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { BulkUpload } from '../model/bulk-upload';
import { ItemMaster, ItemMaster2, ItemSummay, ValidateItemReq, ValidateItemResp, ItemErrorsResponse} from '../model/item';
import { LookUpKeyValueforDomainList } from '../model/lov';
import { Validateitem } from '../model/validateitem';
import { ApiService, lookupCode } from './apiService';
import { ItemZoneModel } from '../model/item';
import { VendorSummay } from '../model/vendor';


@Injectable({
  providedIn: 'root'
})

export class ItemService {

  apiResponse: lookupCode[];
  filterRequest: string = '';
  public dropDownData: Subject<any>;

  constructor(
    private http: HttpClient,
    private api: ApiService
  ) {
    this.dropDownData = new Subject();
  }

  clearFilterRequest() {
    this.filterRequest = '';
  }

  saveItem(itemMaster: ItemMaster): Observable<ItemMaster> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: 'Basic ' + btoa('PPPPortal:Fedex@123'),
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      SERVICE_NAME: 'ITEM_SERVICE',
      'Access-Control-Allow-Origin': '*',
    });
    const options = { headers };
    return this.http.post<any>(environment.apiItemURL, JSON.stringify(itemMaster), options);
  }

  updateItem(itemMaster: ItemMaster): Observable<ItemMaster> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      SERVICE_NAME: 'ITEM_SERVICE',
      'Access-Control-Allow-Origin': '*'
    });
    const options = { headers };
    return this.http.patch<any>(environment.apiItemURL, JSON.stringify(itemMaster), options);
  }

  getItemID(itemID: string): Observable<ItemMaster2> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: { itemId: itemID }
    };
    return this.http.get<ItemMaster2>(environment.apiItemURL, httpOptions);
  }

  validateUniqueBuSku(req: ValidateItemReq): Observable<ValidateItemResp> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      SERVICE_NAME: 'ITEM_SERVICE',
      'Access-Control-Allow-Origin': '*'
    });
    const options = { headers };
    return this.http.post<ValidateItemResp>(environment.apiValidateItem, JSON.stringify(req), options);
  }

  getKeyValue(domainList: string[]): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: { active: 'Y', lookupNames: domainList }
    };
    return this.http.get<LookUpKeyValueforDomainList>(environment.apiLookupURL, httpOptions);
  }

   getSelectedCustomer() {
      return localStorage.getItem('selectedCustomer') ? JSON.parse(localStorage.getItem('selectedCustomer')) : '';
    }

    getSelectedBusinessUnit() {
      return localStorage.getItem('selectedBusinessUnit') ? JSON.parse(localStorage.getItem('selectedBusinessUnit')) : '';
    }

    getSelectedFacility() {
      return localStorage.getItem('selectedFacility') ? JSON.parse(localStorage.getItem('selectedFacility')) : '';
    }


  getItemSummary(cusId: string, pageNumber: string, itmName: string, pageLimit?: string, responseFilter?: string): Observable<ItemSummay> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      }
      // params: {
      //   customerId: cusId,
      //   //buId: this.getSelectedBusinessUnit().buId?.toString(),
      //   //fcyId: this.getSelectedFacility().facilityID?.toString(),
      //   buId: (this.getSelectedBusinessUnit().buId?.toString() == undefined) ? "": this.getSelectedBusinessUnit().buId?.toString(),
      //   fcyId: (this.getSelectedFacility().facilityID?.toString() == undefined) ? "": this.getSelectedFacility().facilityID?.toString(),
      //   responseFilter: responseFilter ? responseFilter : 'summary',
      //   page: pageNumber,
      //   pageLimit: pageLimit ? pageLimit : '10',
      //   itemName: itmName
      // }

    };
    const queryParams = `buId=${encodeURIComponent((this.getSelectedBusinessUnit().buId?.toString() == undefined) ? "": this.getSelectedBusinessUnit().buId?.toString())}&fcyId=${encodeURIComponent((this.getSelectedFacility().facilityID?.toString() == undefined) ? "": this.getSelectedFacility().facilityID?.toString())}&customerId=${encodeURIComponent(cusId)}&responseFilter=${encodeURIComponent( responseFilter ? responseFilter : 'summary')}&page=${encodeURIComponent(pageNumber)}&pageLimit=${encodeURIComponent(pageLimit ? pageLimit : '10')}&itemName=${encodeURIComponent(itmName)}`

  //  return this.http.get<ItemSummay>(environment.apiItemURL, httpOptions);
  return this.http.get<ItemSummay>(`${environment.apiItemURL}?${queryParams}`, httpOptions);

  }


  getItems(validateItem: Validateitem, searchType: string): Observable<Validateitem> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      SERVICE_NAME: 'ITEM_SERVICE',
      'Access-Control-Allow-Origin': '*',
      itemNameSearchType: searchType
    });
    const options = { headers };

    return this.http.post<Validateitem>(environment.apiValidateItem, JSON.stringify(validateItem), options);
  }

  bulkUploadItem(bulkUpload: BulkUpload): Observable<string> {
    return of('make changes to http post bulkupload using http');
  }

  getItemError(
    cusId: number,
    itemErrorId: number
  ):Observable<ItemErrorsResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        custId: cusId != undefined ? cusId.toString() : '0',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID'),
      },
      params: { itemErrorId: itemErrorId != undefined ? itemErrorId.toString() : '0' }
    };
    return this.http.get<ItemErrorsResponse>(
      environment.apiItemURL+"/error",
      httpOptions
   );
  }

  getRecordsforZone(fcyId: string, cusId: string, zoneType: string, pageNum: string, itemId: string): Observable<ItemZoneModel> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID'),
        'Access-Control-Allow-Origin': '*'
      },
      params: { 
        facilityId: fcyId, 
        customerId: cusId, 
        responseFilter: 'summary', 
        page: pageNum, 
        pageLimit: '100', 
        type: zoneType,
        itemId: itemId ? itemId : ''
      }
    };
    return this.http.get<ItemZoneModel>(environment.apiZoneGroupURL, httpOptions);
  }

  getItemsForUpcOrSlp(upcOrItem, upcOrItemCode, custId): Observable<Validateitem> {
      const httpOptions = {
        headers: {
          'Content-Type': 'application/json',
          APPID: environment.apiBussServAPPID,
          UUID: uuid(),
        },
        params: {
          fcyId: this.getSelectedFacility().facilityID?.toString(),
          buId: this.getSelectedBusinessUnit().buId?.toString(),
          custId: custId,
          upcOrSlp: upcOrItem,
          upcOrItemCode: upcOrItemCode,
          source: 'P'
        }
      };
      return this.http.get<Validateitem>(environment.apiItemURL + '/getItemsForUpcOrSlp', httpOptions);
    }

  getVendorsASN(custId: number,searchType: string): Observable<VendorSummay> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: '221',
        UUID: uuid(),
        responseFilter: 'detail',
      },
      params: {
        customerId: (custId).toString(),
        vendorName: searchType,        
      },
    };
  
    return this.http.get<VendorSummay>(environment.apiVendorURL, httpOptions);
  }

}
